import React from 'react';
import styles from './style.module.scss';
import { motion } from 'framer-motion';

const Loader = () => {
    return (
        <motion.div 
            className={styles.loaderContainer}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
        >
            <div className={styles.spinner}></div>
            <p className={styles.text}>Loading Best Holiday...</p>
        </motion.div>
    );
};

export default Loader;
